var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4016 24.8381C36.7301 35.5525 25.877 42.0731 15.1601 39.4012C4.44772 36.7301 -2.07358 25.8775 0.599038 15.1639C3.26931 4.44838 14.1225 -2.07268 24.836 0.598468C35.5521 3.26961 42.073 14.1234 39.4013 24.8383L39.4015 24.8381H39.4016Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0025 12.6934L14.823 17.8723L14.8231 17.8721L11.8096 14.8587L20.0025 6.66675L28.1981 14.8612L25.1844 17.8745L20.0025 12.6934ZM9.68175 16.9862L6.66797 20.0001L9.68154 23.0129L12.6953 19.9995L9.68175 16.9862ZM14.8234 22.1282L20.0029 27.3067L25.1847 22.1257L28.1999 25.1375L28.1984 25.1391L20.0029 33.3334L11.8099 25.1414L11.8057 25.1371L14.8234 22.1282ZM30.3243 16.988L27.3105 20.0014L30.3242 23.0146L33.3379 20.0012L30.3243 16.988Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0586 19.9984H23.0599L20.002 16.9407L17.7418 19.2L17.4822 19.4597L16.9466 19.9953L16.9424 19.9994L16.9466 20.0038L20.002 23.0593L23.0601 20.0016L23.0616 19.9999L23.0588 19.9984",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.add6c0d5423a2ac6e512221161cd30ad.svg";
export { ForwardRef as ReactComponent };